module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/bravesmash.b9b220a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/bravesmash.jpg
// module id = layE
// module chunks = 0